<template>
  <div class="computer">
    <div class="content c895">
      <h2>Dodajte Računalnik</h2>
    </div>
    <div class="content c590">
      <div class="popup popDev7" :style="{display: !err ? 'none' : 'block'}">
        <div class="inner">
          <h3></h3>
          <div class="msg">
            <h3>Izpolniti je potrebno vsaj eno polje za pogostost uporabe naprave!</h3>
          </div>

          <div class="btns">
            <a href="javascript:void(0)" class="btn" title="OK" @click="err = false">V REDU</a>
          </div>
        </div>
      </div>
      <div class="form">
        <h3>VPIŠITE >PODATKE O RAČUNALNIKU</h3>
        <div class="f-item select">
          <label>
            Tip računalnika:
            <span
              id
              style="color:Red;float:none;font-size:1em;"
              :style="{visibility: !err2 ? 'hidden' : 'visible'}"
            >*</span>
            <span>(in zaslona)</span>
          </label>
          <select v-model="tip">
            <option value="0">Izberite</option>
            <option value="1">Prenosni računalnik 12 do 14-palčni zaslon</option>
            <option value="2">Prenosni računalnik 15 do 17-palčni zaslon</option>
            <option value="3">Namizni računalnik + 17-palčni lcd zaslon</option>
            <option value="4">Namizni računalnik + 19-palčni lcd zaslon</option>
            <option value="5">Namizni računalnik + 22-palčni lcd zaslon</option>
            <option value="6">Namizni računalnik + 24-palčni lcd zaslon</option>
            <option value="7">Namizni računalnik + 24-palčni lcd led zaslon</option>
            <option value="8">Namizni računalnik + 17-palčni crt zaslon</option>
            <option value="9">Namizni računalnik + 19-palčni crt zaslon</option>
            <option value="10">Namizni računalnik + 21-palčni crt zaslon</option>
          </select>
        </div>
      </div>
      <div class="question">
        <p>
          Koliko ur
          <b>na teden</b> uporabljate računalnik in kdaj?
        </p>
        <div class="help">
          <a href="#" class="help" title="Help">Help</a>
          <div class="tooltip">
            Na porabo elektrike in višino računa vpliva tarifa, v kateri uporabljate računalnik. Manjša tarifa velja med tednom ponoči (od 22.00 do 6.00) ter ob sobotah, nedeljah ter dela prostih dnevih cel dan.
            <p></p>
          </div>
        </div>
      </div>
      <div class="answer-list">
        <ul>
          <li class="first">
            <div>PON-PET, 6:00-22:00</div>
            <div>PON-PET, 22:00-6:00 IN SOB-NED</div>
          </li>
          <li class="answer odd">
            <span class="small">št. ur</span>
            <div>
              <input type="text" v-model="teden" />
              <span>ur</span>
            </div>
            <div class="last">
              <input type="text" v-model="vikend" />
              <span>ur</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="add">
        <input type="submit" value="Dodaj" @click="addedApplianceNum()" />
      </div>
    </div>
    <div class="content r-c">
      <div class="c282 info">
        <h3>INFO O RAČUNALNIKU</h3>
        <p>Če puščamo naprave, kot so računalnik + monitor + tiskalnik + modem + DSL usmerjevalnik, v stanju pripravljenost (stand by), le te za takšno stanje porabljajo električno energijo. Vsak W (watt) v stanju pripravljenosti plačamo. Zato lahko že z nekaj preprostimi vsakodnevnimi ukrepi precej privarčujemo. Poleg tega lahko na spletu poiščemo številne programe za računalnike, ki nam pomagajo varčevati z električno energijo.</p>

        <div class="average">
          <h4>Povprečna poraba tipičnega računalnika na leto</h4>
          <span>360 kWh/leto</span>
          <p>
            <strong>27,17 € / leto</strong> (enotarifno)
            <br />
            <strong>23,31 € / leto</strong> (dvotarifno)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RacunalnikObj from '../classes/racunalnik';

export default {
  data: function () {
    return {
      tip: '0',
      teden: 0,
      vikend: 0,
      err: false,
      err2: false,
    };
  },
  methods: {
    addedApplianceNum() {
      console.log('From compueter');
      const R = new RacunalnikObj(this.tip, this.teden, this.vikend);
      this.$emit('applianceFormClicked', R);
    },
  },
};
</script>

<style>
</style>